<script setup>
import {computed, defineProps, onMounted, onUnmounted, ref} from 'vue';
import {Link, router, usePage} from "@inertiajs/vue3";
import {trans} from "laravel-vue-i18n";
import BurgerMenuIcon from "@/Svgs/BurgerMenuIcon.svg.vue";
import SmallEvaluation from "@/Components/Evaluation/SmallEvaluation.vue";

const page = usePage();
const lastEvaluations = computed(() => page.props.lastEvaluations);

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['close']);

const closeMenu = () => {
    emit('close');
}

const handleClickOutside = (event) => {
    const burgerMenu = document.querySelector('.mainMenu');
    if (burgerMenu && ! burgerMenu.contains(event.target) && props.isOpen) {
        closeMenu();
    }
}

const handleRouteChange = () => {
    if (props.isOpen) {
        closeMenu();
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
    router.on('success', handleRouteChange);
})

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
})
</script>

<template>
    <Transition :duration="550" name="mainMenu-transition">
        <div
            v-show="isOpen"
            class="mainMenu"
        >
            <BurgerMenuIcon
                @click="closeMenu"
                color="white"
                class="-is-clickable"
                :is-reversed="true"
            />
            <div class="mainMenu-customers">
                <SmallEvaluation
                    v-if="lastEvaluations.length > 0"
                    v-for="evaluation in lastEvaluations"
                    :evaluation="evaluation"
                    :created-date="evaluation.created_at"
                    :updated-date="evaluation.updated_at"
                />
                <template v-else>
                    <p v-text="trans('shared.layout.no-evaluation-text')" />
                </template>
            </div>
            <div
                v-if="lastEvaluations.length > 0"
                class="mainMenu-actions"
            >
                <Link
                    :href="route('evaluations.index')"
                    class="button -is-tertiary"
                    v-text="trans('shared.layout.view-all-evaluations')"
                />
            </div>
        </div>
    </Transition>
</template>

<style lang="scss" scoped>
@use 'include-media/dist/include-media' as *;
@use '~@/base/variables' as *;

.mainMenu {
    position: fixed;
    top: 0;
    transform: translateX(0);
    height: 100vh;
    width: 400px;
    background-color: $blue800;
    color: white;
    padding: 74px 50px 0;
    z-index: 10;

    @include media($breakpoint-phone) {
        padding: 40px 25px 0;
        max-width: 90%;
    }
    &-transition {
        &-enter {
            &-active {
                transition: all 0.3s ease-out;
            }
            &-from {
                transform: translateX(-400px);
            }
        }
        &-leave {
            &-active {
                transition: all 0.3s ease-out;
            }
            &-to {
                transform: translateX(-400px);
            }
        }
    }
    &-customers {
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        gap: 30px;

        &-item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
            color: white;
            text-decoration: none;

            &-title {
                font-weight: 700;
            }
            &-date {
                color: $gray500;
            }
        }
    }
    &-actions {
        display: flex;
        margin-top: 30px;

        a {
            flex: 1
        }
    }
}

</style>
